export class ErroAcessoCursoNaoAutorizado extends Error {
  constructor(message = 'Acesso ao curso não autorizado!') {
    super(message)
    this.name = 'ErroAcessoCursoNaoAutorizado'
  }
}
